
import URLShortener from "@/components/URLShortener";

const Index = () => {
  return <URLShortener />;
};

export default Index;
